window.__SLB_LETTERS_BUILD_TAG__="SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01";
/*
SLB GENERATED FILE — DO NOT EDIT
Project: Saam Law BaseStation (SLB)
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Output: assets/slb.letters.js
Source: slb_src/slices/letters/
Build: slb_build/build_letters.mjs
Built: 2026-09-19 16:53:59.548Z
Content-SHA256: 5a5ab8361012efb9da4b6e1f300cdefbf514fc122c065b61efa1237498b33713
Content-SHA256-12: 5a5ab8361012
*/

/* MIGRATED SOURCE
   Original asset: /assets/slb.letters.js
   Note: This file was copied as-is to bring the module under the slice build pipeline.
   Safe refactor can be done later by splitting into multiple numbered parts.
*/

(function() {
  "use strict";

  function $(id) { return document.getElementById(id); }
  function escapeHtml(s) {
    return String(s||"")
      .replace(/&/g,"&amp;")
      .replace(/</g,"&lt;")
      .replace(/>/g,"&gt;")
      .replace(/"/g,"&quot;")
      .replace(/'/g,"&#039;");
  }

  var DEFAULT_GODS = [{"cn": "天一紫金三羅祖師", "en": "Tin Yat Jee Gum Saam Law Jo Si"}, {"cn": "三羅祖師", "en": "Saam Law Jo Si"}, {"cn": "天羅祖師", "en": "Tin Law Jo Si"}, {"cn": "地羅祖師", "en": "Dei Law Jo Si"}, {"cn": "大羅祖師", "en": "Daai Law Jo Si"}, {"cn": "神龍祖師", "en": "Sun Lung Jo Si"}, {"cn": "金龍仙師", "en": "Gum Lung Sin Si"}, {"cn": "紫龍仙師", "en": "Jee Lung Sin Si"}, {"cn": "五雷仙師", "en": "Ng Lui Sin Si"}, {"cn": "白鶴仙師", "en": "Baak Hork Sin Si"}, {"cn": "八卦祖師", "en": "Bagwa Jo Si"}, {"cn": "土地神明", "en": "Toe Dei Sun Ming (Landlord Deity)"}, {"cn": "門神", "en": "Moon Sun (Door Guardians)"}, {"cn": "廁神", "en": "Chee Sun (Washroom Deity)"}, {"cn": "床神", "en": "Chong Sun (Bedside Deity)"}, {"cn": "灶神", "en": "Jo Sun (Kitchen Deity)"}, {"cn": "家神", "en": "Ga Sun (Family God)"}, {"cn": "上清靈寶天尊", "en": "Sheung Ching Ling Bo Tin Juen"}, {"cn": "玉清元始天尊", "en": "Yuk Ching Yuen Chi Tin Juen"}, {"cn": "太清道德天尊", "en": "Taai Ching Doe Duck Tin Juen"}, {"cn": "元始天王", "en": "Yuen Chi Tin Wong"}, {"cn": "通天教主", "en": "Tung Tin Gaau Jue"}, {"cn": "太上老君", "en": "Taai Sheung Lo Guan"}, {"cn": "三羅本師", "en": "Saam Law Boon Si"}, {"cn": "靈心仙師", "en": "Ling Sum Sin Si"}, {"cn": "天皇大帝", "en": "Tin Wong Daai Dai (Sky Emperor)"}, {"cn": "地皇大帝", "en": "Dei Wong Daai Dai (Ground Emperor)"}, {"cn": "玉皇大帝", "en": "Yuk Wong Daai Dai (Sky Emperor)"}, {"cn": "紫微大帝", "en": "Ji Mei Daai Dai (Ji Mei Emperor)"}, {"cn": "天官大帝", "en": "Tin Goon Daai Dai (Sky Official)"}, {"cn": "地官大帝", "en": "Dei Goon Daai Dai (Ground Official)"}, {"cn": "水官大帝", "en": "Sui Goon Daai Dai (Water Official)"}, {"cn": "太乙救苦天尊", "en": "God of Salvation"}, {"cn": "雷聲普化天尊", "en": "God of Thunder Salvation"}, {"cn": "龍神大帝", "en": "Lung Sun Daai Dai"}, {"cn": "七星劍聖", "en": "Chat Sing Gim Sing (Sword Sage Deity)"}, {"cn": "和聖神尊", "en": "Woh Sing Sun Juen"}, {"cn": "包公大帝", "en": "Bao Gung Daai Dai (Judge Bao)"}, {"cn": "齊天大聖", "en": "Chai Tin Daai Sing (Monkey King God)"}, {"cn": "媽祖娘娘", "en": "Ma Jo Neung Neung (Mazu Goddess)"}, {"cn": "觀音娘娘", "en": "Goon Yum Neung Neung (Guan Yin Goddess)"}, {"cn": "九天玄女", "en": "Gau Tin Yuen Nui"}, {"cn": "六神武聖", "en": "Luk Sun Mo Sing (Martial Deity)"}, {"cn": "天醫仙師", "en": "Tin Yee Sin Si (Celestial Medic Deity)"}, {"cn": "文財正神", "en": "Munn Choy Sun (God of Wealth for Income)"}, {"cn": "武財正神", "en": "Mo Choy Sun (God of Wealth for Spending)"}, {"cn": "五路財神", "en": "Ng Lo Choy Sun (5 Directions Wealth God)"}, {"cn": "地皇財神", "en": "Dei Wong Choy Sun"}, {"cn": "中壇元帥", "en": "Jung Taan Yuen Sui (Central Marshal)"}, {"cn": "天門元帥", "en": "Tin Moon Yuen Sui (Sky Door Marshal)"}, {"cn": "五鬼將軍", "en": "Ng Gwai (5 Ghosts Generals)"}, {"cn": "鍾馗祖師", "en": "Jung Kwai Jo Si"}, {"cn": "雷龍護法神", "en": "Lui Lung Wu Faat Sun (Thunder Dragon Guardian)"}, {"cn": "風虎護法神", "en": "Fung Fu Wu Faat Sun (Wind Tiger Guardian)"}, {"cn": "火鳳護法神", "en": "Foh Fung Wu Faat Sun (Fire Pheonix Guardian)"}, {"cn": "光獅護法神", "en": "Gwong Si Wu Faat Sun (Light Lion Guardian)"}, {"cn": "麒麟護法神", "en": "Kei Lun Wu Faat Sun (K Lun Guardian)"}, {"cn": "三清神龍護法神", "en": "Saam Ching Sun Lung Wu Faat Sun (Saam Ching Dragon Guardian)"}, {"cn": "三羅八仙", "en": "Saam Law Baat Sin (8 Immortals)"}, {"cn": "六壬仙師", "en": "Luk Yum Sin Si"}, {"cn": "和合仙師", "en": "Woh Hup Sin Si (God of Harmony)"}, {"cn": "沖開仙師", "en": "Chung Hoi Sin Si (God of Separation)"}, {"cn": "熾耀仙師", "en": "Chi Yiu Sin Si"}, {"cn": "悟空仙師", "en": "Ng Hung Sin Si"}];

  var GODS = [];
  var selected = [];
  var selectedKeySet = new Set();

  var SAMPLES = [];
  var SAMPLE_BY_ID = new Map();
  var sampleAppliedId = null;

  var currentEntryId = "";
  var readActiveId = "";
  var readActive = null;
  var _saveBusy = false;
  var _readBusy = false;
  var _readListLoaded = false;

  function trimTitle_(s){
    s = String(s||"").trim();
    if(!s) return "";
    // Keep it short for list display.
    if(s.length > 80) return s.slice(0, 77) + "...";
    return s;
  }

  function showToast(msg, isErr){
    var t = $("toast");
    if(!t) return;
    t.textContent = msg;
    // Allow quick ok/err styling.
    t.style.color = isErr ? "#5a1a00" : "#0b3b2e";
    t.style.background = isErr ? "#fff2ec" : "#e6fff6";
    t.style.borderColor = isErr ? "#ffd2bf" : "#b6f2dd";
    t.classList.add("show");
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function(){ t.classList.remove("show"); }, 1800);
  }

  function setSaveBusy_(on){
    _saveBusy = !!on;
    var saveBtn = $("copyBtn");
    var emailBtn = $("emailBtn");
    if(saveBtn){
      // UX: delay the visible "Saving..." unless we're in debug mode.
      try{ if(setSaveBusy_._t) clearTimeout(setSaveBusy_._t); }catch(_e){}
      if(on){
        saveBtn.disabled = true;
        if(!saveBtn.dataset._lbl) saveBtn.dataset._lbl = saveBtn.textContent;

        let pm = 'auto';
        try{ pm = String(sessionStorage.getItem('slb_progressMode') || localStorage.getItem('slb_progressMode') || 'auto').toLowerCase(); }catch(_e){}
        try{ if(pm==='auto'){
          const qs = String((location&&location.search)?location.search:'');
          if(qs){ const p = new URLSearchParams(qs); const dbg = p.get('slbdebug')||p.get('debug'); if(dbg==='1'||dbg==='true') pm='debug'; }
        }}catch(_e){}

        const delay = (pm === 'debug') ? 0 : 2000;
        if(delay <= 0){
          saveBtn.textContent = "Saving...";
        }else{
          setSaveBusy_._t = setTimeout(()=>{ try{ if(saveBtn.disabled) saveBtn.textContent="Saving..."; }catch(_e){} }, delay);
        }
      } else {
        saveBtn.disabled = false;
        if(saveBtn.dataset._lbl){ saveBtn.textContent = saveBtn.dataset._lbl; delete saveBtn.dataset._lbl; }
      }
    }
    if(emailBtn) emailBtn.disabled = !!on;
  }

  function setReadButtonsState_(){
    var refreshBtn = $("slbLettersReadRefreshBtn");
    var editBtn = $("slbLettersReadEditBtn");
    var delBtn = $("slbLettersReadDeleteBtn");
    var hasSel = !!readActiveId;
    if(refreshBtn) refreshBtn.disabled = !_readListLoaded || _readBusy;
    if(editBtn) editBtn.disabled = !hasSel || _readBusy;
    if(delBtn) delBtn.disabled = !hasSel || _readBusy;
  }

  function setReadBusy_(on){
    _readBusy = !!on;
    setReadButtonsState_();
  }

  function showWarn(id){
    var el = $(id);
    if(!el) return;
    el.style.display = "";
    clearTimeout(showWarn._t);
    showWarn._t = setTimeout(function(){ el.style.display="none"; }, 1600);
  }

  function normalizeKey(cn,en){
    return (String(cn||"").trim().toLowerCase() + "||" + String(en||"").trim().toLowerCase());
  }

  function pad2(n){ return String(n).padStart(2,"0"); }
  function formatLongDate(d){
    try{ return d.toLocaleDateString(undefined, {year:"numeric", month:"long", day:"2-digit"}); }
    catch(e){ return d.getFullYear()+"-"+pad2(d.getMonth()+1)+"-"+pad2(d.getDate()); }
  }

  function parseDateKey_(dk){
    dk = String(dk||"").trim();
    if(!dk) return null;

    // Supports YYYY-MM-DD or YYYYMMDD
    var m1 = dk.match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})$/);
    if(m1) return {y:m1[1], m:m1[2], d:m1[3]};

    var m2 = dk.match(/^([0-9]{4})([0-9]{2})([0-9]{2})$/);
    if(m2) return {y:m2[1], m:m2[2], d:m2[3]};

    // Also accept full date strings (e.g. "Sat Jan 24 2026 00:00:00 GMT-0500 ...") and ISO strings.
    var t = Date.parse(dk);
    if(!isNaN(t)){
      var dd = new Date(t);
      return { y: String(dd.getFullYear()), m: pad2(dd.getMonth()+1), d: pad2(dd.getDate()) };
    }
    return null;
  }
  function formatListDate_(dk){
    var p = parseDateKey_(dk);
    if(!p) return String(dk||"");
    return p.m + "-" + p.d + "-" + String(p.y).slice(2);
  }
  function formatMetaDate_(dk){
    var p = parseDateKey_(dk);
    if(!p) return String(dk||"");
    try{
      var dd = new Date(Number(p.y), Number(p.m)-1, Number(p.d));
      return dd.toLocaleDateString(undefined, {year:"numeric", month:"short", day:"numeric"});
    }catch(e){
      return p.y + "-" + p.m + "-" + p.d;
    }
  }

  function getCourtName(){
    var v = $("court") ? $("court").value : "Religious Court";
    if(v === "Custom"){
      var x = $("courtCustom") ? $("courtCustom").value.trim() : "";
      return x || "Religious Court";
    }
    return v;
  }

  function getNameMode(){
    var h = $("nameMode");
    if(h) return (String(h.value||"") || "disciple");
    var modeEl = document.querySelector('input[name="nameMode"]:checked');
    return (modeEl && modeEl.value) ? modeEl.value : "disciple";
  }

  function setNameMode(mode){
    mode = (mode === "minister") ? "minister" : "disciple";
    var h = $("nameMode");
    if(h) h.value = mode;
    var seg = $("slbLettersNameSeg");
    if(seg){
      seg.querySelectorAll('.segBtn').forEach(function(b){
        var m = (b.dataset && b.dataset.mode) ? b.dataset.mode : "";
        b.classList.toggle('active', m === mode);
      });
    }
    // Back-compat (if old radios still exist)
    var r = document.querySelector('input[name="nameMode"][value="'+mode+'"]');
    if(r) r.checked = true;
  }

  function getSignerLines(){
    var mode = getNameMode();
    if(mode === "minister"){
      var name = ($("ministerName") && $("ministerName").value || "").trim();
      var title = ($("ministerTitle") && $("ministerTitle").value || "").trim();
      var signerName = name ? ("Minister " + name) : "Minister (Name)";
      var lines = [signerName];
      if(title) lines.push(title);
      return lines;
    }
    var tn = ($("discipleName") && $("discipleName").value || "").trim();
    return [tn ? ("Disciple " + tn) : "Disciple Tin X"];
  }

  function recipientsText(){
    if(!selected.length) return "";
    return selected.map(function(g){
      return g.cn + (g.en ? (" (" + g.en + ")") : "");
    }).join(", ");
  }

  function buildGodSelect(){
    var sel = $("godPick");
    if(!sel) return;
    sel.innerHTML = "";
    var opt0 = document.createElement("option");
    opt0.value = ""; opt0.textContent = "(Select a god)";
    sel.appendChild(opt0);

    GODS.forEach(function(g){
      var o = document.createElement("option");
      o.value = g.cn;
      o.textContent = g.en ? (g.cn + " — " + g.en) : g.cn;
      sel.appendChild(o);
    });

    var oCustom = document.createElement("option");
    oCustom.value = "__custom__";
    oCustom.textContent = "Custom… (type your own)";
    sel.appendChild(oCustom);
  }

  function renderChips(){
    var wrap = $("godChips");
    if(!wrap) return;
    wrap.innerHTML = "";
    selected.forEach(function(g, idx){
      var chip = document.createElement("div");
      chip.className = "ty-chip";
      chip.innerHTML = "<span>" + escapeHtml(g.cn) + (g.en ? (" ("+escapeHtml(g.en)+")") : "") + "</span>";
      var x = document.createElement("button");
      x.className = "ty-x";
      x.type = "button";
      x.title = "Remove";
      x.setAttribute("aria-label","Remove recipient");
      x.textContent = "×";
      x.addEventListener("click", function(){
        selectedKeySet.delete(g.key);
        selected.splice(idx, 1);
        renderChips();
      });
      chip.appendChild(x);
      wrap.appendChild(chip);
    });
  }

  function onNameModeChange(){
    var mode = getNameMode();
    if(mode === "minister"){
      $("discipleNameWrap").style.display = "none";
      if($("ministerFieldsWrap")) $("ministerFieldsWrap").style.display = "";
      $("ministerNameWrap").style.display = "";
      $("ministerTitleWrap").style.display = "";
      $("discipleName").value = "";
    } else {
      $("discipleNameWrap").style.display = "";
      if($("ministerFieldsWrap")) $("ministerFieldsWrap").style.display = "none";
      $("ministerNameWrap").style.display = "none";
      $("ministerTitleWrap").style.display = "none";
      $("ministerName").value = "";
      $("ministerTitle").value = "";
    }
  }

  function onCourtChange(){
    var wrap = $("courtCustomWrap");
    if(!wrap) return;
    wrap.style.display = ($("court").value === "Custom") ? "" : "none";
  }

  function onGodPickChange(){
    var v = $("godPick").value;
    $("customGodWrap").style.display = (v === "__custom__") ? "" : "none";
    if(v !== "__custom__"){
      $("customGodCn").value = "";
      $("customGodEn").value = "";
    }
  }

  function addRecipient(){
    var v = $("godPick").value;
    if(!v) return;
    var cn="", en="";
    if(v === "__custom__"){
      cn = ($("customGodCn").value || "").trim();
      en = ($("customGodEn").value || "").trim();
      if(!cn){ showWarn("dupWarn"); return; }
    } else {
      var found = GODS.find(function(g){ return g.cn === v; });
      if(!found) return;
      cn = found.cn; en = found.en;
    }

    var key = normalizeKey(cn,en);
    if(selectedKeySet.has(key)){ showWarn("dupWarn"); return; }

    selectedKeySet.add(key);
    selected.push({key:key, cn:cn, en:en});
    renderChips();

    if(v !== "__custom__"){ $("godPick").value = ""; }
    else { $("customGodCn").value=""; $("customGodEn").value=""; $("customGodCn").focus(); }
  }

  function buildSampleSelect(){
    var sel = $("samplePick");
    if(!sel) return;
    sel.innerHTML = "";
    var opt0 = document.createElement("option");
    opt0.value = ""; opt0.textContent = "(Select a sample)";
    sel.appendChild(opt0);

    SAMPLES.forEach(function(s){
      var o = document.createElement("option");
      o.value = s.id;
      o.textContent = s.name;
      sel.appendChild(o);
    });

    $("useSampleBtn").disabled = false;
  }

  function applySampleOnce(){
    var id = $("samplePick").value;
    if(!id) return;
    if(sampleAppliedId){ showWarn("sampleWarn"); return; }

    var s = SAMPLE_BY_ID.get(id);
    if(!s){ showWarn("sampleLoadWarn"); return; }

    if(s.purpose) $("purpose").value = s.purpose;
    if(s.situation) $("situation").value = s.situation;
    if(s.request) $("request").value = s.request;
    if(s.result) $("result").value = s.result;

    sampleAppliedId = id;
    $("useSampleBtn").disabled = true;
    showToast("Sample applied.");
  }

  function clearSample(){
    $("purpose").value = "";
    $("situation").value = "";
    $("request").value = "";
    $("result").value = "";

    sampleAppliedId = null;
    $("useSampleBtn").disabled = false;
    showToast("Sample cleared.");
  }

  function setEditorFromText(txt){
    var area = $("slbLettersBodyRich");
    if(!area) return;
    area.innerHTML = '<div style="white-space:pre-wrap">' + escapeHtml(txt) + '</div>';
  }
  function clearEditor(){
    var area = $("slbLettersBodyRich");
    if(!area) return;
    area.innerHTML = "";
  }
  function getEditorHtml(){
    var area = $("slbLettersBodyRich");
    return area ? (area.innerHTML || "") : "";
  }
  function getEditorPlain(){
    var area = $("slbLettersBodyRich");
    return area ? (area.innerText || "") : "";
  }

  function setEmailEnabled(on){}

  function buildLetter(){
    var court = getCourtName();
    var dateVal = $("letterDate").value;
    var timeVal = $("letterTime").value;

    var whenLine = "Today";
    try{
      var d = dateVal ? new Date(dateVal + "T00:00:00") : new Date();
      var niceDate = formatLongDate(d);
      var niceTime = timeVal ? timeVal : (new Date().toTimeString().slice(0,5));
      whenLine = "Today, " + niceDate + ", at " + niceTime;
    }catch(e){}

    var signerLines = getSignerLines();
    var signerFirst = signerLines[0] || "Disciple Tin X";
    var purpose = ($("purpose").value || "").trim();

    var recips = recipientsText();
    var recipSentence = recips
      ? (" I am writing to " + recips + (purpose ? (" for the purpose of " + purpose + ".") : "."))
      : (purpose ? (" I am writing for the purpose of " + purpose + ".") : ".");

    var situation = ($("situation").value || "").trim();
    var request = ($("request").value || "").trim();
    var result = ($("result").value || "").trim();

    var out = "";
    out += "To the gods of the " + court + ",\n\n";
    out += whenLine + ", I, " + signerFirst + ", write to the " + court + "." + recipSentence + "\n\n";
    if(situation) out += situation + "\n\n";
    if(request) out += request + "\n\n";
    if(result) out += result + "\n\n";
    signerLines.forEach(function(ln){ out += ln + "\n"; });

    try{
      var d2 = dateVal ? new Date(dateVal + "T00:00:00") : new Date();
      out += formatLongDate(d2) + " Submit to " + court + "\n";
    }catch(e){ out += "Submit to " + court + "\n"; }

    setEditorFromText(out);
    currentEntryId = "";
}

  function clearAll(){
    var mode = getNameMode();
    if(mode === "minister"){ $("ministerName").value=""; $("ministerTitle").value=""; }
    else { $("discipleName").value=""; }

    if($("tags")) $("tags").value = "";

    $("purpose").value = "";
    $("situation").value = "";
    $("request").value = "";
    $("result").value = "";

    selected.length = 0;
    selectedKeySet.clear();
    renderChips();

    sampleAppliedId = null;
    $("useSampleBtn").disabled = false;

    clearEditor();

    currentEntryId = "";
}

  function collectMeta(){
    return {
      letterDate: $("letterDate").value || "",
      letterTime: $("letterTime").value || "",
      court: $("court").value || "Religious Court",
      courtCustom: ($("courtCustom") && $("courtCustom").value || ""),
      nameMode: getNameMode(),
      discipleName: ($("discipleName") && $("discipleName").value || ""),
      ministerName: ($("ministerName") && $("ministerName").value || ""),
      ministerTitle: ($("ministerTitle") && $("ministerTitle").value || ""),
      tags: ($("tags") && $("tags").value || ""),
      purpose: ($("purpose") && $("purpose").value || ""),
      situation: ($("situation") && $("situation").value || ""),
      request: ($("request") && $("request").value || ""),
      result: ($("result") && $("result").value || ""),
      recipients: selected.map(function(g){ return {cn:g.cn, en:g.en}; }),
      sampleAppliedId: sampleAppliedId || ""
    };
  }

  function applyMeta(meta){
    meta = meta || {};
    if(meta.letterDate) $("letterDate").value = meta.letterDate;
    if(meta.letterTime) $("letterTime").value = meta.letterTime;

    if(meta.court) $("court").value = meta.court;
    if(meta.courtCustom && $("courtCustom")) $("courtCustom").value = meta.courtCustom;
    onCourtChange();

    if(meta.nameMode) setNameMode(meta.nameMode);
    else setNameMode("disciple");
    onNameModeChange();

    if(meta.discipleName && $("discipleName")) $("discipleName").value = meta.discipleName;
    if(meta.ministerName && $("ministerName")) $("ministerName").value = meta.ministerName;
    if(meta.ministerTitle && $("ministerTitle")) $("ministerTitle").value = meta.ministerTitle;

    if(meta.tags && $("tags")) $("tags").value = meta.tags;

    if(meta.purpose) $("purpose").value = meta.purpose;
    if(meta.situation) $("situation").value = meta.situation;
    if(meta.request) $("request").value = meta.request;
    if(meta.result) $("result").value = meta.result;

    selected.length = 0;
    selectedKeySet.clear();
    var rec = meta.recipients || [];
    rec.forEach(function(r){ 
      if(!r || !r.cn) return;
      var key = normalizeKey(r.cn, r.en||"");
      if(selectedKeySet.has(key)) return;
      selectedKeySet.add(key);
      selected.push({key:key, cn:r.cn, en:r.en||""});
    });
    renderChips();

    sampleAppliedId = meta.sampleAppliedId || null;
    if(sampleAppliedId) $("useSampleBtn").disabled = true;
    else $("useSampleBtn").disabled = false;
  }

  function timeAgo(iso){
    var t = Date.parse(iso||"");
    if(!t) return "";
    var s = Math.floor((Date.now()-t)/1000);
    if(s < 60) return s + "s";
    var m = Math.floor(s/60);
    if(m < 60) return m + "m";
    var h = Math.floor(m/60);
    if(h < 24) return h + "h";
    var d = Math.floor(h/24);
    return d + "d";
  }

  function renderRecords(items, opts){
    var list = $("slbLettersReadList");
    var empty = $("slbLettersReadEmpty");
    if(!list) return;

    list.innerHTML = "";

    if(!items || !items.length){
      if(empty) empty.style.display = "";
      readActiveId = "";
      readActive = null;
      var metaEl = $("slbLettersReadMeta");
      var bodyEl = $("slbLettersReadBody");
      if(metaEl) metaEl.textContent = "No letters yet.";
      if(bodyEl) bodyEl.innerHTML = "";
      _readListLoaded = true;
      setReadButtonsState_();
      return;
    }

    if(empty) empty.style.display = "none";

    // Maintain selection by default; allow override.
    var selectId = (opts && opts.selectId) ? String(opts.selectId) : (readActiveId || "");

    items.forEach(function(it){
      if(!it || !it.entryId) return;
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "slbLettersReadItem";
      btn.dataset.entryId = String(it.entryId||"");
      var upd = timeAgo(it.updatedAt) || "";
      var dateKey = formatListDate_(it.dateKey||"");
      var title = trimTitle_(it.tag||"");
      btn.innerHTML =
        '<div class="slbLettersReadItemTop">' +
          '<div class="slbLettersReadDate">' + escapeHtml(dateKey) + '</div>' +
          '<div class="slbLettersReadUpdated">' + escapeHtml(upd) + '</div>' +
        '</div>' +
        (title ? ('<div class="slbLettersReadTitle">' + escapeHtml(title) + '</div>') : '');

      if(selectId && String(it.entryId) === selectId) btn.classList.add("is-active");
      list.appendChild(btn);
    });

    _readListLoaded = true;

    // Auto-select after save (or if selection still exists).
    if(selectId){
      // If selection is in list, open it; otherwise, clear.
      var inList = null;
      var nodes = list.querySelectorAll('.slbLettersReadItem');
      for(var j=0;j<nodes.length;j++){
        var id = (nodes[j].dataset && nodes[j].dataset.entryId) ? String(nodes[j].dataset.entryId) : "";
        if(id === selectId){ inList = nodes[j]; break; }
      }

      if(inList){
        readActiveId = selectId;
        setReadButtonsState_();
        if(opts && opts.open) loadRead(selectId);
      } else {
        readActiveId = "";
        readActive = null;
        setReadButtonsState_();
      }
    } else {
      setReadButtonsState_();
    }
  }

  function setActiveInList_(){
    var list = $("slbLettersReadList");
    if(!list) return;
    list.querySelectorAll('.slbLettersReadItem').forEach(function(b){
      var id = (b.dataset && b.dataset.entryId) ? b.dataset.entryId : "";
      b.classList.toggle('is-active', !!readActiveId && id === readActiveId);
    });
  }

  async function loadRead(entryId){
    if(!entryId) return;
    setReadBusy_(true);
    try{
      var res = await rpc("lettersGet", {entryId: entryId});
      if(!res) throw new Error("No data");
      readActive = res;
      readActiveId = res.entryId || entryId;
      setActiveInList_();
      var bodyEl = $("slbLettersReadBody");
      var metaEl = $("slbLettersReadMeta");
      var title = trimTitle_(res.tag||"");
      var dateKey = String(res.dateKey||"");
      var upd = timeAgo(res.updatedAt) || "";
      if(metaEl){
        var pretty = formatMetaDate_(dateKey);
        var line1 = escapeHtml(pretty || "");
        if(upd) line1 += '<span class="slbLettersReadMetaUpd">updated ' + escapeHtml(upd) + '</span>';
        var line2 = title ? escapeHtml(title) : "";
        metaEl.innerHTML = (line1 ? ('<div>' + line1 + '</div>') : '') + (line2 ? ('<div class="slbLettersReadMetaSub">' + line2 + '</div>') : '');
      }
      if(bodyEl){
        if(res.bodyRich) bodyEl.innerHTML = res.bodyRich;
        else if(res.body) bodyEl.innerHTML = escapeHtml(res.body).replace(/\n/g, "<br>");
        else bodyEl.innerHTML = "";
      }
    }catch(e){
      showToast("Load failed.", true);
    } finally {
      setReadBusy_(false);
    }
  }

  function parseHashQuery(){
    var h = String(location.hash||"").replace(/^#/, "");
    var out = {tab:"", q:{}};
    if(!h) return out;
    var parts = h.split("?");
    out.tab = parts[0] || "";
    if(parts[1]){
      parts[1].split("&").forEach(function(kv){
        var p = kv.split("=");
        var k = decodeURIComponent(p[0]||"");
        var v = decodeURIComponent(p.slice(1).join("=")||"");
        if(k) out.q[k] = v;
      });
    }
    return out;
  }

  async function rpc(name, payload){
    if(!window.SLB_APP || !window.SLB_APP.rpc) throw new Error("SLB_APP.rpc missing");
    return await window.SLB_APP.rpc(name, payload||{});
  }

  async function loadLookups(){
    try{
      var gRes = await rpc("letterGodsList", {});
      var items = (gRes && gRes.items) ? gRes.items : [];
      // Backend already filters to active rows. If isActive is present, respect it.
      var list = items.filter(function(x){
        if(!x) return false;
        if(!x.cn) return false;
        var a = (x.isActive === undefined || x.isActive === null) ? "1" : String(x.isActive).trim().toLowerCase();
        return (a === "1" || a === "true");
      }).map(function(x){
        var s = Number(x.sort);
        if(!isFinite(s)) s = 9999;
        return {cn:String(x.cn||""), en:String(x.en||""), sort:s};
      });

      if(list.length){
        list.sort(function(a,b){ return (a.sort||0) - (b.sort||0); });
        GODS = list;
      } else {
        GODS = DEFAULT_GODS.slice();
      }

    }catch(e){
      GODS = DEFAULT_GODS.slice();
    }
    buildGodSelect();

    try{
      var sRes = await rpc("letterSamplesList", {});
      var items2 = (sRes && sRes.items) ? sRes.items : [];
      SAMPLES = [];
      SAMPLE_BY_ID = new Map();
      items2.forEach(function(x){
        if(!x) return;
        var id = String(x.sampleId || x.id || "").trim();
        if(!id) return;
        var s = {
          id: id,
          name: String(x.title || x.name || id),
          purpose: String(x.purpose||""),
          situation: String(x.situation||""),
          request: String(x.request||""),
          result: String(x.result||"")
        };
        SAMPLES.push(s);
        SAMPLE_BY_ID.set(s.id, s);
      });
      buildSampleSelect();
    }catch(e){
      $("useSampleBtn").disabled = true;
      $("samplePick").innerHTML = '<option value="">(Failed to load samples)</option>';
      showWarn("sampleLoadWarn");
    }
  }

  async function refreshRecords(opts){
    setReadBusy_(true);
    try{
      var res = await rpc("lettersList", {});
      renderRecords((res && res.items) ? res.items : [], opts);
    }catch(e){
      renderRecords([], opts);
    }finally{
      setReadBusy_(false);
    }
  }

  function ensureOpen_(wrapId, pillId){
    var w = $(wrapId);
    if(!w) return;
    if(w.classList.contains("slbCollapsed")){
      w.classList.remove("slbCollapsed");
      var p = $(pillId);
      if(p) p.textContent = "Hide";
    }
  }

  async function editFromRead_(){
    if(!readActiveId) return;
    await loadEntry(readActiveId, false);
    ensureOpen_("slbLettersBuildWrap", "slbLettersBuildPill");
    try{
      var ed = $("slbLettersStdEditor") || $("slbLettersBodyRich");
      if(ed) ed.scrollIntoView({behavior:"smooth", block:"start"});
    }catch(e){}
  }

  async function deleteFromRead_(){
    if(!readActiveId) return;
    if(_readBusy) return;
    if(!confirm("Delete this letter permanently?")) return;
    setReadBusy_(true);
    showToast("Deleting...");
    try{
      var res = await rpc("lettersDelete", {entryId: readActiveId});
      if(res && res.ok){
        showToast("Deleted.");
        // Clear selection + viewer before refresh.
        readActiveId = "";
        readActive = null;
        var body = $("slbLettersReadBody");
        if(body) body.innerHTML = "";
        var meta = $("slbLettersReadMeta");
        if(meta) meta.textContent = "Select a letter to view.";
        setReadButtonsState_();
        await refreshRecords();
      } else {
        showToast("Delete failed.", true);
      }
    }catch(e){
      showToast("Delete failed.", true);
    }finally{
      setReadBusy_(false);
    }
  }

  async function loadEntry(entryId, reuseAsNew){
    if(!entryId) return;
    try{
      var res = await rpc("lettersGet", {entryId: entryId});
      if(!res) return;
      var meta = null;
      try{ meta = res.metaJson ? JSON.parse(res.metaJson) : null; }catch(e){ meta = null; }
      if(meta) applyMeta(meta);
      if(res.bodyRich){
        var area = $("slbLettersBodyRich");
        if(area) area.innerHTML = res.bodyRich;
      } else if(res.body){
        setEditorFromText(res.body);
      } else {
        clearEditor();
      }

      if(reuseAsNew){
        currentEntryId = "";
showToast("Loaded as new draft.");
      } else {
        currentEntryId = res.entryId || entryId;
showToast("Loaded.");
      }
    }catch(e){
      showToast("Load failed.");
    }
  }

  async function saveCurrent(){
    if(_saveBusy) return;
    var plain = getEditorPlain();
    if(!plain.trim()){ showToast("Nothing to save.", true); return; }

    var metaJson = "";
    try{ metaJson = JSON.stringify(collectMeta()); }catch(e){ metaJson = ""; }

    var tag = "";
    try{
      // Tags only (no fallback to Purpose)
      tag = $("tags") ? String($("tags").value||"").trim() : "";
    }catch(e){ tag = ""; }

    var payload = {
      entryId: currentEntryId || "",
      tag: tag,
      metaJson: metaJson,
      body: plain,
      bodyRich: getEditorHtml()
    };

    try{
      setSaveBusy_(true);
      var _obKey = (payload && payload.entryId) ? ("id:" + String(payload.entryId)) : "";
      var res = await rpc("lettersUpsert", payload, _obKey ? { outbox: { module: "letters", key: _obKey } } : {});
      if(res && res.ok){
        currentEntryId = res.entryId || currentEntryId;
        showToast("Saved.");
        try{ window.dispatchEvent(new CustomEvent("slb:letter-saved", {detail:{entryId:currentEntryId,meta:JSON.parse(metaJson||"{}"),body:plain,bodyRich:payload.bodyRich||""}})); }catch(_eLetterEvent){}
        // Auto-refresh list + open the newly saved record.
        await refreshRecords({selectId: currentEntryId, open: true});
      } else {
        showToast("Save failed.", true);
      }
    }catch(e){
      showToast("Save failed.", true);
    }finally{
      setSaveBusy_(false);
    }
  }

  async function emailSiJuen(){
    if(_saveBusy) return;
    // Always save then send to Si Juen
    await saveCurrent();
    if(!currentEntryId){
      showToast("Save first.", true);
      return;
    }
    var emailBtn = $("emailBtn");
    if(emailBtn) emailBtn.disabled = true;
    showToast("Sending...");
    try{
      var res = await rpc("lettersEmailToSiJuen", {entryId: currentEntryId});
      if(res && res.ok) showToast("Sent to Si Juen.");
      else showToast("Send failed.", true);
    }catch(e){
      showToast("Send failed.", true);
    }finally{
      if(emailBtn) emailBtn.disabled = false;
    }
  }

function bindUI(){
    if(!$("tyLetterBuilder")) return false;

    var now = new Date();
    try{
      $("letterDate").value = now.getFullYear()+"-"+pad2(now.getMonth()+1)+"-"+pad2(now.getDate());
      $("letterTime").value = pad2(now.getHours())+":"+pad2(now.getMinutes());
    }catch(e){}

    // default mode
    setNameMode(getNameMode());
    onNameModeChange();
    onCourtChange();
    onGodPickChange();
    renderChips();

    var seg = $("slbLettersNameSeg");
    if(seg){
      seg.addEventListener("click", function(ev){
        var btn = ev.target && ev.target.closest ? ev.target.closest('.segBtn') : null;
        if(!btn) return;
        var mode = (btn.dataset && btn.dataset.mode) ? btn.dataset.mode : "";
        if(!mode) return;
        setNameMode(mode);
        onNameModeChange();
      });
    }

    // Back-compat: old radios (if present)
    document.querySelectorAll('input[name="nameMode"]').forEach(function(r){ r.addEventListener("change", function(){ setNameMode(r.value); onNameModeChange(); }); });
    $("court").addEventListener("change", onCourtChange);
    $("godPick").addEventListener("change", onGodPickChange);
    $("addGodBtn").addEventListener("click", addRecipient);

    $("useSampleBtn").addEventListener("click", applySampleOnce);
    $("clearSampleBtn").addEventListener("click", clearSample);

    $("buildBtn").addEventListener("click", buildLetter);
    $("clearBtn").addEventListener("click", clearAll);

    $("copyBtn").addEventListener("click", saveCurrent);
    $("emailBtn").addEventListener("click", emailSiJuen);

    var readList = $("slbLettersReadList");
    if(readList){
      readList.addEventListener("click", function(ev){
        var btn = ev.target && ev.target.closest ? ev.target.closest(".slbLettersReadItem") : null;
        if(!btn) return;
        var id = (btn.dataset && btn.dataset.entryId) ? String(btn.dataset.entryId) : "";
        if(!id) return;
        readActiveId = id;
        setActiveInList_();
        setReadButtonsState_();
        loadRead(id);
      });
    }

    var readRefreshBtn = $("slbLettersReadRefreshBtn");
    if(readRefreshBtn) readRefreshBtn.addEventListener("click", function(){ refreshRecords({selectId: readActiveId, open: !!readActiveId}); });
    var readEditBtn = $("slbLettersReadEditBtn");
    if(readEditBtn) readEditBtn.addEventListener("click", function(){ editFromRead_(); });
    var readDelBtn = $("slbLettersReadDeleteBtn");
    if(readDelBtn) readDelBtn.addEventListener("click", function(){ deleteFromRead_(); });

    return true;
  }

  function maybeLoadFromHash(){
    var h = parseHashQuery();
    if(h.tab !== "letters") return;
    if(h.q && h.q.entryId) loadEntry(h.q.entryId, false);
  }

  
  function bindCollapsers(){
    var bt = $("slbLettersBuildToggle");
    var bw = $("slbLettersBuildWrap");
    var bp = $("slbLettersBuildPill");
    var rt = $("slbLettersRecordToggle");
    var rw = $("slbLettersRecordWrap");
    var rp = $("slbLettersRecordPill");

    function setPill(p, collapsed){
      if(!p) return;
      p.textContent = collapsed ? "Show" : "Hide";
    }
    function toggle(w, p){
      if(!w) return;
      var collapsed = w.classList.toggle("slbCollapsed");
      setPill(p, collapsed);
    }
    function onKey(e, cb){
      if(e.key === "Enter" || e.key === " "){
        e.preventDefault();
        cb();
      }
    }

    if(bt && bw){
      setPill(bp, bw.classList.contains("slbCollapsed"));
      bt.addEventListener("click", function(){ toggle(bw, bp); });
      bt.addEventListener("keydown", function(e){ onKey(e, function(){ toggle(bw, bp); }); });
    }
    if(rt && rw){
      setPill(rp, rw.classList.contains("slbCollapsed"));
      rt.addEventListener("click", function(){ toggle(rw, rp); });
      rt.addEventListener("keydown", function(e){ onKey(e, function(){ toggle(rw, rp); }); });
    }
  }

function boot(){
    if(!$("slbLettersPanel")) return;
    if(!bindUI()) return;
    bindCollapsers();
    loadLookups();
    refreshRecords();
    maybeLoadFromHash();
    window.addEventListener("hashchange", function(){
      var h = parseHashQuery();
      if(h.tab === "letters"){ refreshRecords(); maybeLoadFromHash(); }
    });
  }

  setTimeout(boot, 0);
})();
